import React, { Component } from 'react';
import { GetLastQuarterEndDate, ReportType, GetFormatedDate, makeLinkForQuickbooks, formatCurrencyAmount } from '../../../common/commonServices';
import { GET_REPORT_DATA, MARK_IGNORED_DATA, Revert_Ignored_DATA, UPDATE_DESCRIPTION_DATA, UPSERT_TRANSACTION_TO_BE_REVIEWED_SETTINGS, IGNORE_VENDOR, UNIGNORE_VENDOR, GET_IGNORED_VENDORS } from '../../../../appRedux/actions/ReportDetailAction';
import { LedgerUpdate } from '../../../../appRedux/actions/LedgerAction';
import { Accounts } from '../../../../appRedux/actions/accountAction';
import { getCompnay, getStates } from '../../../../appRedux/actions/companiesAction';
import moment from 'moment';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import CircularProgress from './../../../../components/CircularProgress';
import { toast } from 'react-toastify';
import Button from '@material-ui/core/Button';
import Switch from '@material-ui/core/Switch';
import Dialog from '@material-ui/core/Dialog';
import DialogContent from '@material-ui/core/DialogContent';
import DialogActions from '@material-ui/core/DialogActions';
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import "../../styles.css";
import RSelect from 'react-select';
import Textarea from 'react-expanding-textarea';
import _ from 'lodash';
import './DataEntryIssues.css';
import { Popover, PopoverBody } from 'reactstrap';

const SALES_TAX_WA_PREPARES = 'W&A prepares sales tax returns';
const STATE_SALE_TAX_OPTIONS = [
    { value: '', label: 'Select' },
    { value: 'Pending Compliance Review', label: 'Pending Compliance Review' },
    { value: 'Pending Registration with the State', label: 'Pending Registration with the State' },
    { value: SALES_TAX_WA_PREPARES, label: SALES_TAX_WA_PREPARES },
    { value: 'Client prepares sales tax returns', label: 'Client prepares sales tax returns' },
    { value: 'Sales Are Tax Exempt', label: 'Sales Are Tax Exempt' }
];

//Confirm Group Medical Coverage title-row dropdown (blank default)
const GROUP_MEDICAL_COVERAGE_OPTIONS = [
    { value: '', label: 'Select' },
    { value: 'Pending Compliance Review', label: 'Pending Compliance Review' },
    { value: 'Client has Group Medical Coverage', label: 'Client has Group Medical Coverage' },
    { value: 'ACA Violations', label: 'ACA Violations' }
];

//Confirm Personal vs Keyman Life Insurance title-row dropdown (blank default)
const PERSONAL_VS_KEYMAN_LIFE_INSURANCE_OPTIONS = [
    { value: '', label: 'Select' },
    { value: 'Pending Compliance Review', label: 'Pending Compliance Review' },
    { value: 'Client Has Personal Life Insurance Benefits', label: 'Client Has Personal Life Insurance Benefits' }
];

// Display order of the TBR sections (top to bottom)
const TBR_SECTION_ORDER = [
    'paymentsCodedToIncomeAccounts',
    'depositsCodedToExpensesAccounts',
    'transactionsCodedToAccumulatedDepreciationAccount',
    'reviewRepairsAndMaintenanceTransactions',
    'reclassifyBuildingImprovements',
    'reviewFixedAssetAdditions',
    'reviewOtherEmployeeBenefits',
    'transactionsInAccountsWithNoAccountNumber',
    'stateSalesTaxCompliance',
    'reviewForPotentialUBIT',
    'confirmGroupMedicalCoverage',
    'confirmPersonalVsKeymanLifeInsurance',
    'reviewPotentialACAViolations',
    'reviewPotentialPersonalVehicleExpenseIssues',
    'confirmBusinessVehicleExpenses'
];

// Review for Potential UBIT title-row dropdown (blank default)
const UBIT_WA_PREPARES_990T = 'W&A prepares 990-T Tax returns';
const REVIEW_FOR_POTENTIAL_UBIT_OPTIONS = [
    { value: '', label: 'Select' },
    { value: 'Pending Compliance Review', label: 'Pending Compliance Review' },
    { value: UBIT_WA_PREPARES_990T, label: UBIT_WA_PREPARES_990T }
];

// TBR title-row dropdown sizing: put the react-select value back in flow so long labels
// are not cut off at 320px, and let the menu size to its widest option.
// Section info popover text (client-supplied). A section without an entry shows no info icon.
const TBR_SECTION_INFO = {
    paymentsCodedToIncomeAccounts: "The client may be recording payments to the wrong entity type. Reimbursements to customers are fine. Payments to 1099 vendors will need to be edited and assigned to a vendor for 1099 reporting. Payments to employees where the payment should be reported on a W-2 require CPA review.",
    depositsCodedToExpensesAccounts: "These transactions should only be for reimbursements or refunds from vendors. Other transactions require CPA review.",
    transactionsCodedToAccumulatedDepreciationAccount: "Review the transaction to categorize to the correct account. There should only be depreciation expense and adjusting entries for the sale or disposition of assets coded to these accounts.",
    reviewRepairsAndMaintenanceTransactions: "Review these transactions to determine if they should be capitalized as leasehold improvements (if the client leases the property), building improvements (if the client owns the property and makes major building upgrades) or furniture and fixtures. Refer to the fixed assets handout.",
    reviewForPotentialUBIT: "If the non-profit organization is selling merchandise that is not related to their exempt purpose, the transactions are subject to unrelated business income taxes (UBIT). Examples: A church starts operating a business that sells furniture. A church rents its facility to a for-profit business to host an event to promote their products. A church rents its vacant parking lot for truck parking. A non-profit may rent its space for religious, charitable and educational use. This use is related to their purpose.",
    reviewFixedAssetAdditions: "Confirm all fixed assets are categorized correctly. Reclassify transactions under $250 unless the transaction can be grouped with other transactions. Reclassify original purchases and refunds when they do not net to over $250 (e.g. Original purchase $500, refund $450). Reclassify both transactions to the proper supplies expense account. Building improvements should be for major upgrades. Reclassify smaller purchases to R&M expense or furniture and fixtures. Review the Fixed Asset Chart for more information.",
    reclassifyBuildingImprovements: "This client does not own a building. Confirm these improvements are for a space the client is renting. If so, these transactions should be reclassified to leasehold improvements.",
    reviewPotentialACAViolations: "Payment of these transactions are a violation of the Affordable Care Act: Direct payment to a health insurance company for a personal health insurance policy, payment of medical expenses, prescriptions, etc. Companies should have a qualified health reimbursement plan that covers all qualified employees. Otherwise any payment of medical expenses is a violation of the Affordable Care Act. Vision care and dental care are not included for the ACA violation. However, the payment of these expenses should be reported as taxable fringe benefits (TFB). Send a Basecamp message to the client using the ACA Violation template.",
    reviewPotentialPersonalVehicleExpenseIssues: "This client does not own any vehicles. Reimbursements for mileage is non-taxable. Gas for rental cars are legitimate business expenses. Gas purchases for a personal vehicle should be tagged as taxable fringe benefits (TFB).",
    confirmBusinessVehicleExpenses: "This client owns one or more vehicles. Confirm all transactions are for company vehicles or vehicle rentals. Reimbursements for mileage is non-taxable. Gas for vehicle rentals are legitimate business expenses. Gas purchases for a personal vehicle should be tagged as taxable fringe benefits (TFB).",
    reviewOtherEmployeeBenefits: "Most personal expenses paid on behalf of employees are taxable fringe benefits. Payments for seminars and workshops should be classified as employee training. However, payments for college tuition should be reported as taxable fringe benefits. If the organization adopts a policy to cover qualified education costs for all employees subject to IRS limits and qualifications, college tuition costs may be non-taxable.",
    confirmGroupMedicalCoverage: "This client is paying for health insurance. Confirm the coverage is for group health insurance. Request the client to include \"group\" in the description in the future. Payment for personal health insurance is a violation of the Affordable Care Act. Send a Basecamp message to the client using the ACA Violation template.",
    confirmPersonalVsKeymanLifeInsurance: "The client is paying for life insurance. Payment of life insurance on a policy where the organization is the 100% beneficiary is a Keyman Life Insurance policy and is non-taxable. If any portion of the life insurance benefit goes to a personal designated beneficiary, a portion of the premium is a taxable fringe benefit. We may have copies of the policy and beneficiaries on file. We should confirm beneficiaries at least once every 3 years.",
    transactionsInAccountsWithNoAccountNumber: "Review the client's chart of accounts to confirm this is not a duplicate account. If not, assign the account an account number. Confirm the account type is correct. If the account is an income or expense account, make sure it appears in the correct section of the report; and with the correct parent/sub-account structure.",
    stateSalesTaxCompliance: "This client is selling merchandise. Research the sales tax reporting requirements for the client's state to determine whether there are any exemptions that allow non-profits to sell merchandise. Example: Some states allow churches to sell bibles and not have to charge sales tax for the transaction. Others may allow a minimum dollar amount of sales or occasional sales before the organization is required to charge sales taxes and file sales tax returns."
};

// Document icon for the section info popover; inherits the row icon colour.
const TbrInfoDocIcon = () => (
    <svg className="tbr-info-icon-svg" viewBox="0 0 280 340" width="14" height="17" aria-hidden="true" focusable="false"
        fill="none" stroke="currentColor" strokeWidth="26" strokeLinecap="round" strokeLinejoin="round">
        <path d="M200 13H38a25 25 0 0 0-25 25v264a25 25 0 0 0 25 25h204a25 25 0 0 0 25-25V80z" />
        <path d="M200 13v67h67" />
        <line x1="70" y1="150" x2="210" y2="150" strokeWidth="20" />
        <line x1="70" y1="210" x2="210" y2="210" strokeWidth="20" />
        <line x1="70" y1="270" x2="210" y2="270" strokeWidth="20" />
    </svg>
);

const tbrTitleSelectStyles = {
    container: base => ({ ...base, minWidth: 320, display: 'inline-block', textAlign: 'left' }),
    valueContainer: base => ({ ...base, overflow: 'visible', flexWrap: 'nowrap' }),
    singleValue: base => ({
        ...base,
        position: 'static',
        top: 'auto',
        transform: 'none',
        maxWidth: 'none',
        overflow: 'visible',
        textOverflow: 'clip',
        whiteSpace: 'nowrap'
    }),
    menuPortal: base => Object.assign({}, base, { zIndex: 9999 }),
    menu: base => ({ ...base, width: 'max-content', minWidth: '100%', zIndex: 9999 }),
    option: base => ({ ...base, whiteSpace: 'nowrap' })
};

/* portal New Account menu so table overflow/edit-row layout cannot clip it */
const tbrNewAccountSelectStyles = {
    control: base => ({ ...base, minHeight: 38 }),
    valueContainer: base => ({ ...base, overflow: 'visible' }),
    singleValue: base => ({ ...base, overflow: 'visible', textOverflow: 'clip', maxWidth: '100%' }),
    menuPortal: base => Object.assign({}, base, { zIndex: 9999 }),
    menu: base => ({ ...base, zIndex: 9999 })
};

const defaultTbrSettings = (companyId) => ({
    companyID: companyId,
    stateSaleTaxOption: null,
    reviewPotentialACADate: null,
    reviewPotentialPersonalVehicleExpenseDate: null,
    businessVehicleExpensesDate: null,
    groupMedicalCoverageOption: null,
    personalVsKeymanLifeInsuranceOption: null,
    reviewForPotentialUBITOption: null
});

class TransactionsToBeReviewComponent extends Component {

    constructor(props) {
        super(props)

        this.sDateRef = React.createRef();
        this.eDateRef = React.createRef();
        this.acaDateRef = React.createRef();
        this.tbrTableWrapRef = React.createRef(); // info popover stays within the table horizontally
        this.vehicleDateRef = React.createRef();
        this.businessVehicleDateRef = React.createRef();

        // Previous default date logic based on last quarter
        // End date = Last Quarter End Date
        // let eDate = GetLastQuarterEndDate();
        // Start date = January 1st of the same year as eDate
        // let sDate = new Date(eDate.getFullYear(), 0, 1);

        // Initialize dates based on company QuickBooks sync years (similar to CompanyDashboard)
        const companyBeginningYear = (props.company && props.company.quickbooksDataSyncBeginningYear) || 2019;
        const companyEndingYear = props.company ? props.company.quickbooksDataSyncEndingYear : null;

        let sDate = new Date(companyBeginningYear, 0, 1);
        // If ending year is null, use today's date
        let eDate = companyEndingYear
            ? new Date(companyEndingYear, 11, 31)
            : new Date();

        this.state = {
            eDate: eDate,
            sDate: sDate,
            loading: false,
            reportData: null,
            editedData: null,
            companyId: 0,
            sortField: 'date',
            sortFormat: "D",
            isIgnore: false,
            showAllSections: false,  // off: sections with 0 rows are hidden
            ignoredVendors: [],      // Vendors ignored for Confirm Group Medical Coverage
            ignoredVendorsOpen: false,
            confirmDialog: null,     // { message, onConfirm }
            isDataLoaded: false,
            SelectedRecords: [],
            expandedCategories: [],
            infoCategoryKey: null,   // section whose info popover is open
            infoPinned: false,       // opened by click; stays open until an outside click
            selectedIgnoreByCategory: {}, // Track Ignore selections by category
            editIndex1: -1,
            editIndex: -1,
            editData: null,
            accounts: [],
            DisplayAccounts: [],
            selectedAccount: { value: 0, label: "Select" },
            pendingDescriptionBody: null,
            pendingTfbOnlySave: false,
            tbrSettings: defaultTbrSettings(0),
            savingTbrSettings: false
        }
    }

    buildTbrSettingsFromReport = (reportData, companyId) => {
        const settings = reportData && reportData.settings;
        if (!settings) {
            return defaultTbrSettings(companyId);
        }

        return {
            companyID: settings.companyID || settings.CompanyID || companyId,
            stateSaleTaxOption: settings.stateSaleTaxOption || settings.StateSaleTaxOption || null,
            reviewPotentialACADate: settings.reviewPotentialACADate || settings.ReviewPotentialACADate || null,
            reviewPotentialPersonalVehicleExpenseDate: settings.reviewPotentialPersonalVehicleExpenseDate || settings.ReviewPotentialPersonalVehicleExpenseDate || null,
            businessVehicleExpensesDate: settings.businessVehicleExpensesDate || settings.BusinessVehicleExpensesDate || null,
            groupMedicalCoverageOption: settings.groupMedicalCoverageOption || settings.GroupMedicalCoverageOption || null,
            personalVsKeymanLifeInsuranceOption: settings.personalVsKeymanLifeInsuranceOption || settings.PersonalVsKeymanLifeInsuranceOption || null,
            reviewForPotentialUBITOption: settings.reviewForPotentialUBITOption || settings.ReviewForPotentialUBITOption || null
        };
    }

    buildTbrSettingsPayload = (overrides = {}) => {
        const base = this.state.tbrSettings || defaultTbrSettings(this.state.companyId);
        return {
            companyID: this.state.companyId,
            stateSaleTaxOption: base.stateSaleTaxOption || null,
            reviewPotentialACADate: base.reviewPotentialACADate || null,
            reviewPotentialPersonalVehicleExpenseDate: base.reviewPotentialPersonalVehicleExpenseDate || null,
            businessVehicleExpensesDate: base.businessVehicleExpensesDate || null,
            groupMedicalCoverageOption: base.groupMedicalCoverageOption || null,
            personalVsKeymanLifeInsuranceOption: base.personalVsKeymanLifeInsuranceOption || null,
            reviewForPotentialUBITOption: base.reviewForPotentialUBITOption || null,
            ...overrides
        };
    }

    saveTbrSettings = (payload, successMessage, onSaved) => {
        this.setState({ savingTbrSettings: true });
        this.props.UPSERT_TRANSACTION_TO_BE_REVIEWED_SETTINGS(payload)
            .then((result) => {
                const apiResult = (result && result.data) ? result.data : result;
                if (apiResult && apiResult.transactionStatus === 0 && apiResult.returnObject) {
                    this.setState({
                        tbrSettings: this.buildTbrSettingsFromReport({ settings: apiResult.returnObject }, this.state.companyId),
                        savingTbrSettings: false
                    });
                    toast.success(successMessage || 'Settings saved.');
                    if (onSaved) onSaved();
                } else {
                    this.setState({ savingTbrSettings: false });
                    toast.error((apiResult && apiResult.resultMsg) || 'Unable to save settings.');
                }
            })
            .catch(() => {
                this.setState({ savingTbrSettings: false });
            });
    }

    onStateSaleTaxOptionChange = (selectedOption) => {
        const value = selectedOption && selectedOption.value ? selectedOption.value : null;
        // The SP returns no State Sales Tax rows while W&A prepares the returns, so reload them when switching away
        const reloadRows = this.isSalesTaxPreparedByWA() && value !== SALES_TAX_WA_PREPARES;
        this.setState((prev) => ({
            tbrSettings: { ...prev.tbrSettings, stateSaleTaxOption: value }
        }));
        this.saveTbrSettings(
            this.buildTbrSettingsPayload({ stateSaleTaxOption: value }),
            'Sales tax status saved.',
            reloadRows ? () => this.GetReportData() : null
        );
    }

    // Google search for the client's state (full name), added to the State Sales Tax Compliance note.
    // No state on the company: generic wording and no link.
    renderSalesTaxSearch = () => {
        const code = ((this.props.company && this.props.company.state) || '').trim();
        // The stored value may be a code or a name, in any case (ks, KS, Kansas).
        const key = code.toLowerCase();
        const match = code
            ? (this.props.states || []).find(s => (s.stateVchID || '').toLowerCase() === key || (s.vchStateLongName || '').toLowerCase() === key)
            : null;
        const stateName = code ? (match ? match.vchStateLongName : code) : null;
        const question = `Do nonprofit organizations in ${stateName || "the client's state"} that sell merchandise have to collect sales taxes?`;
        return (
            <p style={{ marginTop: '8px', marginBottom: 0 }}>
                Perform a Google search:{' '}
                {stateName
                    ? <a className="tbr-info-search-link" href={'https://www.google.com/search?q=' + encodeURIComponent(question)} target="_blank" rel="noopener noreferrer">&ldquo;{question}&rdquo;</a>
                    : <React.Fragment>&ldquo;{question}&rdquo;</React.Fragment>}
            </p>
        );
    }

    isSalesTaxPreparedByWA = () => (
        ((this.state.tbrSettings && this.state.tbrSettings.stateSaleTaxOption) || '') === SALES_TAX_WA_PREPARES
    )

    getSelectedStateSaleTaxOption = () => {
        const current = (this.state.tbrSettings && this.state.tbrSettings.stateSaleTaxOption) || '';
        return STATE_SALE_TAX_OPTIONS.find(option => option.value === current) || STATE_SALE_TAX_OPTIONS[0];
    }

    //Confirm Group Medical Coverage title-row dropdown
    onGroupMedicalCoverageOptionChange = (selectedOption) => {
        const value = selectedOption && selectedOption.value ? selectedOption.value : null;
        this.setState((prev) => ({
            tbrSettings: { ...prev.tbrSettings, groupMedicalCoverageOption: value }
        }));
        this.saveTbrSettings(
            this.buildTbrSettingsPayload({ groupMedicalCoverageOption: value }),
            'Group medical coverage status saved.'
        );
    }

    getSelectedGroupMedicalCoverageOption = () => {
        const current = (this.state.tbrSettings && this.state.tbrSettings.groupMedicalCoverageOption) || '';
        return GROUP_MEDICAL_COVERAGE_OPTIONS.find(option => option.value === current) || GROUP_MEDICAL_COVERAGE_OPTIONS[0];
    }

    // Confirm Personal vs Keyman Life Insurance title-row dropdown
    onPersonalVsKeymanLifeInsuranceOptionChange = (selectedOption) => {
        const value = selectedOption && selectedOption.value ? selectedOption.value : null;
        this.setState((prev) => ({
            tbrSettings: { ...prev.tbrSettings, personalVsKeymanLifeInsuranceOption: value }
        }));
        this.saveTbrSettings(
            this.buildTbrSettingsPayload({ personalVsKeymanLifeInsuranceOption: value }),
            'Life insurance status saved.'
        );
    }

    getSelectedPersonalVsKeymanLifeInsuranceOption = () => {
        const current = (this.state.tbrSettings && this.state.tbrSettings.personalVsKeymanLifeInsuranceOption) || '';
        return PERSONAL_VS_KEYMAN_LIFE_INSURANCE_OPTIONS.find(option => option.value === current) || PERSONAL_VS_KEYMAN_LIFE_INSURANCE_OPTIONS[0];
    }

    // Review for Potential UBIT title-row dropdown
    onReviewForPotentialUBITOptionChange = (selectedOption) => {
        const value = selectedOption && selectedOption.value ? selectedOption.value : null;
        // The SP returns no UBIT rows while W&A prepares the 990-T, so reload them when switching away
        const reloadRows = this.isUbitPreparedByWA() && value !== UBIT_WA_PREPARES_990T;
        this.setState((prev) => ({
            tbrSettings: { ...prev.tbrSettings, reviewForPotentialUBITOption: value }
        }));
        this.saveTbrSettings(
            this.buildTbrSettingsPayload({ reviewForPotentialUBITOption: value }),
            'UBIT status saved.',
            reloadRows ? () => this.GetReportData() : null
        );
    }

    getSelectedReviewForPotentialUBITOption = () => {
        const current = (this.state.tbrSettings && this.state.tbrSettings.reviewForPotentialUBITOption) || '';
        return REVIEW_FOR_POTENTIAL_UBIT_OPTIONS.find(option => option.value === current) || REVIEW_FOR_POTENTIAL_UBIT_OPTIONS[0];
    }

    isUbitPreparedByWA = () => (
        ((this.state.tbrSettings && this.state.tbrSettings.reviewForPotentialUBITOption) || '') === UBIT_WA_PREPARES_990T
    )

    parseTbrSettingsDate = (value) => {
        if (!value) return null;
        const parsed = moment(value);
        return parsed.isValid() ? parsed.toDate() : null;
    }

    onReviewPotentialACADateChange = (date) => {
        const value = date
            ? moment.utc([date.getFullYear(), date.getMonth(), date.getDate()]).toISOString()
            : null;
        this.setState((prev) => ({
            tbrSettings: { ...prev.tbrSettings, reviewPotentialACADate: value }
        }));
        this.saveTbrSettings(
            this.buildTbrSettingsPayload({ reviewPotentialACADate: value }),
            'ACA notice date saved.'
        );
    }

    onReviewPotentialPersonalVehicleExpenseDateChange = (date) => {
        const value = date
            ? moment.utc([date.getFullYear(), date.getMonth(), date.getDate()]).toISOString()
            : null;
        this.setState((prev) => ({
            tbrSettings: { ...prev.tbrSettings, reviewPotentialPersonalVehicleExpenseDate: value }
        }));
        this.saveTbrSettings(
            this.buildTbrSettingsPayload({ reviewPotentialPersonalVehicleExpenseDate: value }),
            'Vehicle notice date saved.'
        );
    }

    //separate date column BusinessVehicleExpensesDate
    onBusinessVehicleExpensesDateChange = (date) => {
        const value = date
            ? moment.utc([date.getFullYear(), date.getMonth(), date.getDate()]).toISOString()
            : null;
        this.setState((prev) => ({
            tbrSettings: { ...prev.tbrSettings, businessVehicleExpensesDate: value }
        }));
        this.saveTbrSettings(
            this.buildTbrSettingsPayload({ businessVehicleExpensesDate: value }),
            'Business vehicle notice date saved.'
        );
    }

    // TFB edit row on ACA, Personal Vehicle, Confirm Business Vehicle, Other Employee Benefits, Group Medical Coverage, Personal vs Keyman Life Insurance
    isTfbEditCategory = (categoryKey) => (
        categoryKey === 'reviewPotentialACAViolations'
        || categoryKey === 'reviewPotentialPersonalVehicleExpenseIssues'
        || categoryKey === 'confirmBusinessVehicleExpenses'
        || categoryKey === 'reviewOtherEmployeeBenefits'
        || categoryKey === 'confirmGroupMedicalCoverage'
        || categoryKey === 'confirmPersonalVsKeymanLifeInsurance'
    )

    componentDidMount() {
        const user = JSON.parse(localStorage.getItem('userData'));
        if (!user || !user.companyId) return;
        // Ensure company details (including QuickBooks sync years) are loaded on mount
        this.props.getCompnay(user.companyId);
        // State names for the State Sales Tax Compliance note (loaded once per session)
        if (!this.props.states || this.props.states.length === 0) this.props.getStates();
        // Set companyId and dispatch the Redux action to get the Transaction To Be Reviewed data
        this.setState({ companyId: user.companyId }, () => {
            this.GetReportData();
            this.props.Accounts(user.companyId);
            this.loadIgnoredVendors();
        });
        
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.ReportData !== this.props.ReportData) {
            // Expand all categories by default
            const allCategoryKeys = [
                'paymentsCodedToIncomeAccounts',
                'depositsCodedToExpensesAccounts',
                //'paymentsAssignedToCustomer',
                'transactionsCodedToAccumulatedDepreciationAccount',
                'reviewRepairsAndMaintenanceTransactions',
                'reclassifyBuildingImprovements',
                'reviewPotentialACAViolations',
                'reviewPotentialPersonalVehicleExpenseIssues',
                'confirmBusinessVehicleExpenses',
                'reviewOtherEmployeeBenefits',
                'confirmGroupMedicalCoverage',
                'confirmPersonalVsKeymanLifeInsurance',
                'transactionsInAccountsWithNoAccountNumber',
                'stateSalesTaxCompliance',
                'reviewForPotentialUBIT',
                'reviewFixedAssetAdditions'
            ];

            this.setState({
                reportData: nextProps.ReportData.returnObject,
                tbrSettings: this.buildTbrSettingsFromReport(nextProps.ReportData.returnObject, this.state.companyId),
                isDataLoaded: true,
                loading: false,
                //expandedCategories: allCategoryKeys       //[2026-01-28]Commented out to prevent default expansion on page load
            });
            return;
        }

        if (nextProps.accounts != undefined && nextProps.accounts !== this.props.accounts) {
            let searchableAccounts = [];
            if (nextProps.accounts.data != null && nextProps.accounts.data.length > 0) {
                searchableAccounts = _.sortBy(nextProps.accounts.data, ['accountNumber', 'name']).map((value, index) => (
                    { value: value.accountID, label: (value.accountNumber != null ? value.accountNumber + ' ' + value.name : value.name) }
                ))
            }
            let defaultValue = { value: 0, label: "Select" };
            searchableAccounts.unshift(defaultValue);
            this.setState({
                accounts: nextProps.accounts.data,
                DisplayAccounts: searchableAccounts
            });
        }

        if (nextProps.UpdateDescription !== this.props.UpdateDescription) {
            if (nextProps.UpdateDescription.transactionStatus === 0) {
                // If this is from row update (not ignore/revert), show success and reload
                if (this.state.pendingDescriptionBody) {
                    this.setState({
                        loading: false,
                        selectedIgnoreByCategory: {},
                        editIndex1: -1,
                        editIndex: -1,
                        editData: null,
                        pendingDescriptionBody: null
                    }, () => {
                        toast.success("Transaction updated successfully");
                        this.GetReportData();
                    });
                } else {
                    // From ignore/revert action
                    this.setState({
                        loading: true,
                        selectedIgnoreByCategory: {},
                        editIndex1: -1,
                        editIndex: -1,
                        editData: null
                    }, () => {
                        this.GetReportData();
                    });
                }
            }
            else {
                this.setState({ loading: false });
            }
        }

        // Update date range when company QuickBooks sync years are available/changed
        if (nextProps.company && nextProps.company !== this.props.company) {
            const companyBeginningYear = nextProps.company.quickbooksDataSyncBeginningYear || 2019;
            const companyEndingYear = nextProps.company.quickbooksDataSyncEndingYear;

            const sDate = new Date(companyBeginningYear, 0, 1);
            // If ending year is null, use today's date
            const eDate = companyEndingYear
                ? new Date(companyEndingYear, 11, 31)
                : new Date();

            this.setState({
                sDate,
                eDate
            });
        }

        if (nextProps.LEDGER_UPDATE !== undefined && nextProps.LEDGER_UPDATE !== this.props.LEDGER_UPDATE) {
            if (nextProps.LEDGER_UPDATE.transactionStatus === 0) {
                // TFB-only save: do not call UPDATE_DESCRIPTION_DATA / rewrite other GL fields
                if (this.state.pendingTfbOnlySave) {
                    this.setState({
                        loading: false,
                        selectedIgnoreByCategory: {},
                        editIndex1: -1,
                        editIndex: -1,
                        editData: null,
                        pendingDescriptionBody: null,
                        pendingTfbOnlySave: false
                    }, () => {
                        toast.success("TFB updated successfully.");
                        this.GetReportData();
                    });
                } else if (this.state.pendingDescriptionBody) {
                    // LedgerUpdate successful, now call UPDATE_DESCRIPTION_DATA
                    this.props.UPDATE_DESCRIPTION_DATA(this.state.pendingDescriptionBody);
                }
            }
            else {
                this.setState({
                    loading: false,
                    editIndex1: -1,
                    editIndex: -1,
                    editData: null,
                    pendingDescriptionBody: null,
                    pendingTfbOnlySave: false
                }, () => {
                    toast.error(`${nextProps.LEDGER_UPDATE.resultMsg}`);
                });
            }
        }
    }

    GetReportData(IsRefresh = false) {
        let state = this.state;
        let body = {
            companyID: state.companyId,
            reportType: ReportType.TransactionsToBeReview,
            fromDate: moment(state.sDate).format("MM/DD/YYYY"),
            toDate: moment(state.eDate).format("MM/DD/YYYY"),
            sortField: state.sortField,
            sortFormat: state.sortFormat,
            isIgnore: state.isIgnore,
            // pageNumber: state.PageNo,
            // pageSize: state.PageSize,
            // needUpdatQBORecords: IsRefresh,
        };

        this.setState({
            loading: true
        }, () => {
            this.props.GET_REPORT_DATA(body);
        });
    }

    HandleIgnored = (event) => {
        this.setState({ isIgnore: (event.target.value == "true" ? true : false), loading: true, isDataLoaded: false }, () => { this.GetReportData() });
    }

    //Used for Datepicker
    handleDateChange = (e, target) => {
        if (target === "fromDate") {
            this.setState({ sDate: new Date(e), selectedDateRange: { startDate: moment(new Date(e)).format("MM/DD/YYYY"), endDate: moment(this.state.eDate).format("MM/DD/YYYY") } })
        }
        else if (target === "uptoDate") {
            const newEDate = new Date(e);
            // When eDate changes, recalculate sDate as January 1st of that year
            const newSDate = new Date(newEDate.getFullYear(), 0, 1);
            this.setState({ eDate: newEDate, sDate: newSDate, selectedDateRange: { startDate: moment(newSDate).format("MM/DD/YYYY"), endDate: moment(newEDate).format("MM/DD/YYYY") } })
        }
    }

    //Used for Datepicker
    handleFocus = (e, selecter) => {
        let control = null;
        if (selecter === 'sDate') {
            control = this.sDateRef;
        } else if (selecter === 'acaDate') {
            control = this.acaDateRef;
        } else if (selecter === 'vehicleDate') {
            control = this.vehicleDateRef;
        } else if (selecter === 'businessVehicleDate') {
            control = this.businessVehicleDateRef;
        } else if (selecter !== undefined) {
            control = this.eDateRef;
        }
        if (control && control.current != null) {
            control.current.setFocus();
        }
    }

    ApplyDate = () => {
        this.GetReportData();
    }

    onSortChange = (fieldName) => {
        if (this.state.sortField === fieldName) {
            let formate = this.state.sortFormat === 'A' ? 'D' : 'A';
            this.setState({ sortFormat: formate, loading: true, isDataLoaded: false }, () => {
                this.GetReportData();
            });
        } else {
            this.setState({ sortField: fieldName, sortFormat: 'A', loading: true, isDataLoaded: false }, () => {
                this.GetReportData();
            });
        }
    }

    // Helper method to check if there's any data in the reportData object
    hasReportData = () => {
        if (!this.state.reportData) return false;

        return (
            (this.state.reportData.paymentsCodedToIncomeAccounts && this.state.reportData.paymentsCodedToIncomeAccounts.length > 0) ||
            (this.state.reportData.depositsCodedToExpensesAccounts && this.state.reportData.depositsCodedToExpensesAccounts.length > 0) ||
            (this.state.reportData.transactionsInAccountsWithNoAccountNumber && this.state.reportData.transactionsInAccountsWithNoAccountNumber.length > 0) ||
            // As per client request - disable Payments assigned to a Customer
            //(this.state.reportData.paymentsAssignedToCustomer && this.state.reportData.paymentsAssignedToCustomer.length > 0) ||
            (this.state.reportData.transactionsCodedToAccumulatedDepreciationAccount && this.state.reportData.transactionsCodedToAccumulatedDepreciationAccount.length > 0) ||
            (this.state.reportData.reviewRepairsAndMaintenanceTransactions && this.state.reportData.reviewRepairsAndMaintenanceTransactions.length > 0) ||
            (this.state.reportData.reviewForPotentialUBIT && this.state.reportData.reviewForPotentialUBIT.length > 0) ||
            (this.state.reportData.reclassifyBuildingImprovements && this.state.reportData.reclassifyBuildingImprovements.length > 0) ||
            (this.state.reportData.reviewPotentialACAViolations && this.state.reportData.reviewPotentialACAViolations.length > 0) ||
            (this.state.reportData.reviewPotentialPersonalVehicleExpenseIssues && this.state.reportData.reviewPotentialPersonalVehicleExpenseIssues.length > 0) ||
            (this.state.reportData.confirmBusinessVehicleExpenses && this.state.reportData.confirmBusinessVehicleExpenses.length > 0) ||
            (this.state.reportData.reviewOtherEmployeeBenefits && this.state.reportData.reviewOtherEmployeeBenefits.length > 0) ||
            (this.state.reportData.confirmGroupMedicalCoverage && this.state.reportData.confirmGroupMedicalCoverage.length > 0) ||
            (this.state.reportData.confirmPersonalVsKeymanLifeInsurance && this.state.reportData.confirmPersonalVsKeymanLifeInsurance.length > 0) ||
            (this.state.reportData.stateSalesTaxCompliance && this.state.reportData.stateSalesTaxCompliance.length > 0) ||
            (this.state.reportData.reviewFixedAssetAdditions && this.state.reportData.reviewFixedAssetAdditions.length > 0)
        );
    }

    // Helper method to get all transactions from all arrays
    getAllTransactions = () => {
        if (!this.state.reportData) return [];

        const transactions = [];

        if (this.state.reportData.paymentsCodedToIncomeAccounts) {

            transactions.push(...this.state.reportData.paymentsCodedToIncomeAccounts);
        }
        if (this.state.reportData.depositsCodedToExpensesAccounts) {
            transactions.push(...this.state.reportData.depositsCodedToExpensesAccounts);
        }
        if (this.state.reportData.transactionsInAccountsWithNoAccountNumber) {
            transactions.push(...this.state.reportData.transactionsInAccountsWithNoAccountNumber);
        }
        // As per client request - disable Payments assigned to a Customer
        //if (this.state.reportData.paymentsAssignedToCustomer) {
        //    transactions.push(...this.state.reportData.paymentsAssignedToCustomer);
        //}
        if (this.state.reportData.transactionsCodedToAccumulatedDepreciationAccount) {
            transactions.push(...this.state.reportData.transactionsCodedToAccumulatedDepreciationAccount);
        }
        if (this.state.reportData.reviewRepairsAndMaintenanceTransactions) {
            transactions.push(...this.state.reportData.reviewRepairsAndMaintenanceTransactions);
        }
        if (this.state.reportData.reviewForPotentialUBIT) {
            transactions.push(...this.state.reportData.reviewForPotentialUBIT);
        }
        if (this.state.reportData.reclassifyBuildingImprovements) {
            transactions.push(...this.state.reportData.reclassifyBuildingImprovements);
        }
        if (this.state.reportData.reviewPotentialACAViolations) {
            transactions.push(...this.state.reportData.reviewPotentialACAViolations);
        }
        if (this.state.reportData.reviewPotentialPersonalVehicleExpenseIssues) {
            transactions.push(...this.state.reportData.reviewPotentialPersonalVehicleExpenseIssues);
        }
        if (this.state.reportData.confirmBusinessVehicleExpenses) {
            transactions.push(...this.state.reportData.confirmBusinessVehicleExpenses);
        }
        if (this.state.reportData.reviewOtherEmployeeBenefits) {
            transactions.push(...this.state.reportData.reviewOtherEmployeeBenefits);
        }
        if (this.state.reportData.confirmGroupMedicalCoverage) {
            transactions.push(...this.state.reportData.confirmGroupMedicalCoverage);
        }
        if (this.state.reportData.confirmPersonalVsKeymanLifeInsurance) {
            transactions.push(...this.state.reportData.confirmPersonalVsKeymanLifeInsurance);
        }
        if (this.state.reportData.stateSalesTaxCompliance) {
            transactions.push(...this.state.reportData.stateSalesTaxCompliance);
        }
        if (this.state.reportData.reviewFixedAssetAdditions) {
            transactions.push(...this.state.reportData.reviewFixedAssetAdditions);
        }

        return transactions;
    }

    // Method to get categorized transaction data
    getCategorizedData = () => {
        if (!this.state.reportData) return [];

        const categories = [
            {
                key: 'paymentsCodedToIncomeAccounts',
                label: 'Payments Coded to Income Accounts',
                data: this.state.reportData.paymentsCodedToIncomeAccounts || []
            },
            {
                key: 'depositsCodedToExpensesAccounts',
                label: 'Deposits Coded to Expenses Accounts',
                data: this.state.reportData.depositsCodedToExpensesAccounts || []
            },
            // As per client request - disable Payments assigned to a Customer
            //{
            //    key: 'paymentsAssignedToCustomer',
            //    label: 'Payments assigned to a Customer',
            //    data: this.state.reportData.paymentsAssignedToCustomer || []
            //},
            {
                key: 'transactionsCodedToAccumulatedDepreciationAccount',
                label: 'Transactions Coded to an Accumulated Depreciation Account',
                data: this.state.reportData.transactionsCodedToAccumulatedDepreciationAccount || []
            },
           
            {
                key: 'reviewRepairsAndMaintenanceTransactions',
                label: 'Review Repairs and Maintenance Transactions',
                data: this.state.reportData.reviewRepairsAndMaintenanceTransactions || []
            },
            {
                key: 'reclassifyBuildingImprovements',
                label: 'Reclassify Building Improvements',
                data: this.state.reportData.reclassifyBuildingImprovements || []
            },
            {
                key: 'reviewPotentialACAViolations',
                label: 'Review Potential ACA Violation or Taxable Fringe Benefits',
                data: this.state.reportData.reviewPotentialACAViolations || []
            },
            {
                key: 'reviewPotentialPersonalVehicleExpenseIssues',
                label: 'Review Potential Personal Vehicle Expense Issues',
                data: this.state.reportData.reviewPotentialPersonalVehicleExpenseIssues || []
            },
            {
                key: 'confirmBusinessVehicleExpenses',
                label: 'Confirm Business Vehicle Expenses',
                data: this.state.reportData.confirmBusinessVehicleExpenses || []
            },
            {
                key: 'reviewOtherEmployeeBenefits',
                label: 'Review Other Employee Benefits',
                data: this.state.reportData.reviewOtherEmployeeBenefits || []
            },
            {
                key: 'confirmGroupMedicalCoverage',
                label: 'Confirm Group Medical Coverage',
                data: this.state.reportData.confirmGroupMedicalCoverage || []
            },
            {
                key: 'confirmPersonalVsKeymanLifeInsurance',
                label: 'Confirm Personal vs Keyman Life Insurance',
                data: this.state.reportData.confirmPersonalVsKeymanLifeInsurance || []
            },
            {
                key: 'transactionsInAccountsWithNoAccountNumber',
                label: 'Accounts Missing an Account Number',
                data: this.state.reportData.transactionsInAccountsWithNoAccountNumber || []
            },
            {
                key: 'stateSalesTaxCompliance',
                label: 'State Sales Tax Compliance',
                data: this.isSalesTaxPreparedByWA() ? [] : (this.state.reportData.stateSalesTaxCompliance || [])
            },
            {
                key: 'reviewForPotentialUBIT',
                label: 'Review for Potential UBIT',
                data: this.isUbitPreparedByWA() ? [] : (this.state.reportData.reviewForPotentialUBIT || [])
            },
            {
                key: 'reviewFixedAssetAdditions',
                label: 'Review Fixed Asset Additions',
                data: this.state.reportData.reviewFixedAssetAdditions || []
            },
        ];

        // Return all categories, even if empty, in TBR_SECTION_ORDER
        return _.sortBy(categories, category => TBR_SECTION_ORDER.indexOf(category.key));
    }

    // Sections with 0 rows are hidden unless Show All is on; order and categoryIndex are unchanged
    getVisibleCategories = () => (
        this.getCategorizedData()
            .map((category, categoryIndex) => ({ ...category, categoryIndex }))
            .filter(category => this.state.showAllSections || category.data.length > 0)
    )

    toggleShowAllSections = () => {
        this.setState(prev => ({ showAllSections: !prev.showAllSections }));
    }

    // Confirm Group Medical Coverage - Ignore Vendor
    loadIgnoredVendors = () => {
        if (!this.state.companyId) return;
        this.props.GET_IGNORED_VENDORS(this.state.companyId, ReportType.TBRGroupMedicalIgnoreVendor)
            .then((result) => {
                const list = result && result.transactionStatus === 0 && Array.isArray(result.returnObject) ? result.returnObject : [];
                this.setState({ ignoredVendors: list });
            })
            .catch(() => { });
    }

    // Only Group Medical rows paid to a vendor (VendorID 0 = employee/customer/blank payee)
    canIgnoreVendor = (categoryKey, transaction) => (
        categoryKey === 'confirmGroupMedicalCoverage' && !!transaction && Number(transaction.vendorID) > 0
    )

    // Ignored view: a row hidden only through Ignore Vendor has no per-row ignore to revert
    isVendorOnlyIgnored = (transaction) => (
        !!this.state.isIgnore && !!transaction && !!transaction.isVendorIgnored && !transaction.isIgnore
    )

    getIgnoreSelectableRows = (rows) => (rows || []).filter(transaction => !this.isVendorOnlyIgnored(transaction))

    getVendorLabel = (transaction) => (transaction && (transaction.vendor || transaction.name)) || 'this vendor'

    openConfirm = (message, onConfirm) => this.setState({ confirmDialog: { message, onConfirm } })

    closeConfirm = () => this.setState({ confirmDialog: null })

    onConfirmDialogContinue = () => {
        const dialog = this.state.confirmDialog;
        this.closeConfirm();
        if (dialog && dialog.onConfirm) dialog.onConfirm();
    }

    saveVendorIgnore = (transaction, ignore) => {
        const companyID = this.state.companyId;
        const reportType = ReportType.TBRGroupMedicalIgnoreVendor;
        const request = ignore
            ? this.props.IGNORE_VENDOR({ companyID, reportType, glIds: [transaction.id] })
            : this.props.UNIGNORE_VENDOR({ companyID, reportType, vendorIds: [Number(transaction.vendorID)] });
        return request
            .then((result) => {
                if (!result || result.transactionStatus !== 0) {
                    toast.error((result && result.resultMsg) || 'Unable to update the vendor.');
                    return false;
                }
                this.loadIgnoredVendors();
                return true;
            })
            .catch(() => false);
    }

    restoreIgnoredVendor = (vendor) => {
        // Close the vendor list so only the confirmation shows
        this.setState({ ignoredVendorsOpen: false });
        this.openConfirm(`Restore all Confirm Group Medical Coverage transactions for ${vendor.vendorName}?`, () => {
            this.props.UNIGNORE_VENDOR({ companyID: this.state.companyId, reportType: ReportType.TBRGroupMedicalIgnoreVendor, vendorIds: [vendor.vendorID] })
                .then((result) => {
                    if (result && result.transactionStatus === 0) {
                        toast.success('Vendor restored.');
                        this.loadIgnoredVendors();
                        this.GetReportData();
                    } else {
                        toast.error((result && result.resultMsg) || 'Unable to restore the vendor.');
                    }
                })
                .catch(() => { });
        });
    }

    // Any edit-row change other than Ignore Vendor
    hasRowEdits = (rowData) => {
        const editData = this.state.editData || {};
        const rowNewAccountId = rowData.newAccountId && rowData.newAccountId > 0 ? Number(rowData.newAccountId) : 0;
        const editNewAccountId = editData.newAccountID && editData.newAccountID > 0 ? Number(editData.newAccountID) : 0;
        return rowNewAccountId !== editNewAccountId
            || !!rowData.taxableFringeBenefit !== !!editData.taxableFringeBenefit
            || !!rowData.needsBetterDescription !== !!editData.needsBetterDescription
            || (rowData.accountantComment || '') !== (editData.accountantComment || '')
            || (rowData.internalNotes || '') !== (editData.internalNotes || '')
            || (rowData.memoOrDescription || '') !== (editData.memoOrDescription || '');
    }

    // Check if a category is expanded
    isCategoryExpanded = (categoryKey) => {
        return this.state.expandedCategories.indexOf(categoryKey) > -1;
    }

    // Toggle category expansion
    toggleCategory = (categoryKey) => {
        let items = [...this.state.expandedCategories];
        if (this.isCategoryExpanded(categoryKey)) {
            items.splice(items.indexOf(categoryKey), 1);
        } else {
            items.push(categoryKey);
        }
        this.setState({ expandedCategories: items });
    }

    // Info icon: hover previews, click pins; never reaches the row's expand/collapse handler.
    onInfoIconEnter = (categoryKey) => {
        if (this.state.infoPinned && this.state.infoCategoryKey === categoryKey) return;
        this.setState({ infoCategoryKey: categoryKey, infoPinned: false });
    }

    onInfoIconLeave = () => {
        if (!this.state.infoPinned) this.setState({ infoCategoryKey: null });
    }

    onInfoIconClick = (e, categoryKey) => {
        e.stopPropagation();
        this.setState({ infoCategoryKey: categoryKey, infoPinned: true });
    }

    onInfoIconKeyDown = (e, categoryKey) => {
        if (e.key === 'Enter' || e.key === ' ') {
            e.preventDefault();
            this.onInfoIconClick(e, categoryKey);
        }
    }

    closeInfoPopover = () => {
        this.setState({ infoCategoryKey: null, infoPinned: false });
    }

    // Handle "Select All" checkbox in category header for Ignore column
    handleSelectAllIgnoreCategory = (categoryKey, categoryData, isChecked) => {
        const updatedSelectedIgnoreByCategory = { ...this.state.selectedIgnoreByCategory };

        if (isChecked) {
            // Select all transactions in this category
            updatedSelectedIgnoreByCategory[categoryKey] = categoryData.map(trans => trans.id || trans.transactionId);
        } else {
            // Deselect all transactions in this category
            updatedSelectedIgnoreByCategory[categoryKey] = [];
        }

        this.setState({ selectedIgnoreByCategory: updatedSelectedIgnoreByCategory });
    }

    // Handle individual transaction Ignore checkbox
    handleIgnoreCheckbox = (categoryKey, transactionId, isChecked) => {
        const updatedSelectedIgnoreByCategory = { ...this.state.selectedIgnoreByCategory };

        if (!updatedSelectedIgnoreByCategory[categoryKey]) {
            updatedSelectedIgnoreByCategory[categoryKey] = [];
        }

        if (isChecked) {
            // Add to selection if not already present
            if (!updatedSelectedIgnoreByCategory[categoryKey].includes(transactionId)) {
                updatedSelectedIgnoreByCategory[categoryKey].push(transactionId);
            }
        } else {
            // Remove from selection
            const index = updatedSelectedIgnoreByCategory[categoryKey].indexOf(transactionId);
            if (index > -1) {
                updatedSelectedIgnoreByCategory[categoryKey].splice(index, 1);
            }
        }

        this.setState({ selectedIgnoreByCategory: updatedSelectedIgnoreByCategory });
    }

    // Handle individual transaction NBD checkbox
    handleNeedBetterDescriptionCheckbox = (categoryKey, transactionId, isChecked) => {
        // This method is kept for backward compatibility but NBD is now only in edit row
        // No longer updates from row checkboxes
    }

    // Check if a specific transaction is selected for Ignore
    isTransactionIgnoreSelected = (categoryKey, transactionId) => {
        const categorySelections = this.state.selectedIgnoreByCategory[categoryKey];
        return categorySelections && categorySelections.includes(transactionId) ? true : false;
    }

    // Check if all transactions in a category are selected for Ignore
    isCategoryAllIgnoreSelected = (categoryKey, categoryData) => {
        if (!categoryData || categoryData.length === 0) return false;

        const categorySelections = this.state.selectedIgnoreByCategory[categoryKey];
        if (!categorySelections || categorySelections.length === 0) return false;

        const allTransactionIds = categoryData.map(trans => trans.id || trans.transactionId);
        return allTransactionIds.every(id => categorySelections.includes(id));
    }

    isTransactionNbdChecked = (transaction) => {
        return !!(transaction && (transaction.needsBetterDescription || transaction.NeedsBetterDescription));
    }

    // Account # / New Account #: "number name" (number omitted when empty)
    formatAccountLabel = (accountNumber, accountName) => {
        const num = (accountNumber != null && accountNumber !== '') ? String(accountNumber).trim() : '';
        const name = (accountName != null && accountName !== '') ? String(accountName).trim() : '';
        if (num && name) return `${num} ${name}`;
        return num || name || '';
    }

    resolveNewAccountNumber = (transaction) => {
        if (!transaction) return '';
        const fromApi = transaction.newAccountNumber != null ? transaction.newAccountNumber : transaction.NewAccountNumber;
        if (fromApi != null && fromApi !== '') return fromApi;
        const id = transaction.newAccountId != null ? transaction.newAccountId : transaction.NewAccountId;
        if (id && this.state.accounts && this.state.accounts.length > 0) {
            const acc = this.state.accounts.find(x => x.accountID == id);
            if (acc && acc.accountNumber != null && acc.accountNumber !== '') return acc.accountNumber;
        }
        return '';
    }

    formatNewAccountLabel = (transaction) => {
        const name = transaction.newAccountName != null ? transaction.newAccountName : transaction.NewAccountName;
        return this.formatAccountLabel(this.resolveNewAccountNumber(transaction), name);
    }

    OnApplyIgnored = () => {
        // Flatten all selected records from all categories
        let selectedData = [];
        Object.keys(this.state.selectedIgnoreByCategory).forEach(categoryKey => {
            selectedData = selectedData.concat(this.state.selectedIgnoreByCategory[categoryKey]);
        });

        if (selectedData == null || selectedData.length === 0) {
            toast.error("Please select atleast 1 record for processing request");
            return false;
        }

        let body = {
            "ids": selectedData,
            "reportType": ReportType.TransactionsToBeReview,
            "companyID": this.state.companyId
        }

        this.setState({ loading: true }, () => {
            if (this.state.isIgnore) {
                this.props.Revert_Ignored_DATA(body);
            }
            else {
                this.props.MARK_IGNORED_DATA(body);
            }
        });
    }

    onRowClick = (e, categoryKey, categoryIndex, transactionIndex, rowData) => {
        if (this.state.editData && this.state.editIndex1 > -1 && this.state.editIndex > -1) {
            this.onRowCancelClick(this.state.editIndex1, this.state.editIndex, null);
        }

        // Initialize selectedAccount based on existing newAccountId
        let selectedAccount = { value: 0, label: "Select" };
        if (rowData.newAccountId && rowData.newAccountId > 0) {
            const foundAccount = this.state.DisplayAccounts.find(acc => acc.value === rowData.newAccountId);
            if (foundAccount) {
                selectedAccount = foundAccount;
            }
        }

        let data = {
            needsBetterDescription: rowData.needsBetterDescription,
            taxableFringeBenefit: rowData.taxableFringeBenefit || false,
            ignoreVendor: !!rowData.isVendorIgnored,
            accountantComment: rowData.accountantComment || '',
            internalNotes: rowData.internalNotes || '',
            memoOrDescription: rowData.memoOrDescription || '',
            newAccountID: rowData.newAccountId && rowData.newAccountId > 0 ? rowData.newAccountId : null,
            newAccountName: rowData.newAccountName || null
        }
        this.setState({
            editIndex1: categoryIndex,
            editIndex: transactionIndex,
            editData: data,
            selectedAccount: selectedAccount
        });
    }

    onRowCancelClick = (categoryIndex, transactionIndex, rowData) => {
        this.setState({
            editIndex1: -1,
            editIndex: -1,
            editData: null
        });
    }

    handalAccountDropdown = (e, categoryIndex, transactionIndex, rowData) => {
        if (e.value == null || e.value == 0) {
            let editData = { ...this.state.editData };
            editData.newAccountID = null;
            editData.newAccountName = null;
            editData.newAccountNumber = null;
            this.setState({ editData: editData, selectedAccount: e });
        }
        else {
            let obj = this.state.accounts.find(x => x.accountID == e.value);
            let editData = { ...this.state.editData };
            editData.newAccountID = e.value;
            editData.newAccountName = obj.name;
            editData.newAccountNumber = obj.accountNumber;
            this.setState({ editData: editData, selectedAccount: e });
        }
    }

    handalCheckbox = (e, categoryIndex, transactionIndex, rowData) => {
        let editData = { ...this.state.editData };
        editData[e.target.name] = e.target.checked;
        this.setState({ editData: editData });
    }

    handalTextArea = (e, categoryIndex, transactionIndex, rowData) => {
        let editData = { ...this.state.editData };
        editData[e.target.name] = e.target.value;
        this.setState({ editData: editData });
    }

    onRowUpdateClick = (categoryIndex, transactionIndex, rowData) => {
        const categoryKey = (this.getCategorizedData()[categoryIndex] || {}).key;
        const ignoreVendor = !!(this.state.editData && this.state.editData.ignoreVendor);
        if (!this.canIgnoreVendor(categoryKey, rowData) || ignoreVendor === !!rowData.isVendorIgnored) {
            this.saveRowEdits(categoryIndex, transactionIndex, rowData);
            return;
        }

        // Ignore Vendor has its own endpoint; save it first, then any other edits
        const vendor = this.getVendorLabel(rowData);
        const message = ignoreVendor
            ? `All Confirm Group Medical Coverage transactions for ${vendor}, including future ones, will be ignored. Continue?`
            : `Restore all Confirm Group Medical Coverage transactions for ${vendor}?`;
        this.openConfirm(message, () => {
            this.setState({ loading: true });
            this.saveVendorIgnore(rowData, ignoreVendor).then((saved) => {
                if (!saved) {
                    this.setState({ loading: false });
                    return;
                }
                if (this.hasRowEdits(rowData)) {
                    this.saveRowEdits(categoryIndex, transactionIndex, rowData);
                    return;
                }
                toast.success(ignoreVendor ? 'Vendor ignored.' : 'Vendor restored.');
                this.setState({ editIndex1: -1, editIndex: -1, editData: null });
                this.GetReportData();
            });
        });
    }

    saveRowEdits = (categoryIndex, transactionIndex, rowData) => {
        const originalTfb = !!(rowData.taxableFringeBenefit);
        const editedTfb = !!(this.state.editData && this.state.editData.taxableFringeBenefit);
        // TFB-only save only when TFB is the sole change; otherwise the full save below (TFB included) so no edit is dropped.
        const editData = this.state.editData || {};
        const rowNewAccountId = rowData.newAccountId && rowData.newAccountId > 0 ? Number(rowData.newAccountId) : 0;
        const editNewAccountId = editData.newAccountID && editData.newAccountID > 0 ? Number(editData.newAccountID) : 0;
        const otherChanged = rowNewAccountId !== editNewAccountId
            || !!rowData.needsBetterDescription !== !!editData.needsBetterDescription
            || (rowData.accountantComment || '') !== (editData.accountantComment || '')
            || (rowData.internalNotes || '') !== (editData.internalNotes || '')
            || (rowData.memoOrDescription || '') !== (editData.memoOrDescription || '');
        const isTfbOnlyUpdate = originalTfb !== editedTfb && !otherChanged;

        // TFB is the only change: persist only TaxableFringeBenefit — keep all other GL fields from the row as-is
        if (isTfbOnlyUpdate) {
            const existingNewAccountId = rowData.newAccountId && rowData.newAccountId > 0
                ? Number(rowData.newAccountId)
                : 0;
            const tfbOnlyData = {
                id: rowData.id,
                transactionTypeId: rowData.transactionTypeId || 0,
                transactionType: rowData.transactionType,
                accountId: rowData.accountID || 0,
                newAccountId: existingNewAccountId,
                needsBetterDescription: rowData.needsBetterDescription || false,
                transferCodedIncorrectly: rowData.transferCodedIncorrectly || false,
                cpaReview: rowData.cpaReview || false,
                pcCheck: rowData.pcCheck || false,
                accountantComment: rowData.accountantComment || '',
                internalNotes: rowData.internalNotes || '',
                taxableFringeBenefit: editedTfb,
                updateTaxableFringeBenefitOnly: true,
                vendor1099: rowData.vendor1099 || false,
                taxReporting: rowData.taxReporting || false,
                isArchived: rowData.isArchived || false,
                benefitTypeId: rowData.benefitTypeId || 0,
                employeeName: rowData.employeeName || '',
                clientComment: rowData.clientComment || '',
                accountChangeApprovedByClient: rowData.accountChangeApprovedByClient || false,
                clientReviewStatus: rowData.clientReviewStatus || false,
                accountantReviewStatus: rowData.accountantReviewStatus || false,
                descriptionNeedsEmployeeName: rowData.descriptionNeedsEmployeeName || false,
                clientApprovedTaxableFringeBenefit: rowData.clientApprovedTaxableFringeBenefit || false,
                accountantPostedTaxableFringeBenefit: rowData.accountantPostedTaxableFringeBenefit || false,
                memoOrDescription: rowData.memoOrDescription || ''
            };

            this.setState({
                loading: true,
                pendingDescriptionBody: null,
                pendingTfbOnlySave: true
            }, () => {
                this.props.LedgerUpdate(tfbOnlyData, this.state.companyId, "TFB updated successfully.");
            });
            return;
        }

        let newAccountId = this.state.editData.newAccountID;
        let finalNewAccountId = 0;
        if (newAccountId && newAccountId > 0) {
            finalNewAccountId = Number(newAccountId);
        }

        let data = {
            id: rowData.id,
            transactionTypeId: rowData.transactionTypeId || 0,
            transactionType: rowData.transactionType,
            accountId: rowData.accountID || 0,
            newAccountId: finalNewAccountId,
            needsBetterDescription: this.state.editData.needsBetterDescription || false,
            transferCodedIncorrectly: rowData.transferCodedIncorrectly || false,
            cpaReview: rowData.cpaReview || false,
            pcCheck: rowData.pcCheck || false,
            accountantComment: this.state.editData.accountantComment,
            internalNotes: this.state.editData.internalNotes,
            taxableFringeBenefit: this.state.editData.taxableFringeBenefit || false,
            vendor1099: rowData.vendor1099 || false,
            taxReporting: rowData.taxReporting || false,
            isArchived: rowData.isArchived || false,
            benefitTypeId: rowData.benefitTypeId || 0,
            employeeName: rowData.employeeName || '',
            clientComment: rowData.clientComment || '',
            accountChangeApprovedByClient: rowData.accountChangeApprovedByClient || false,
            clientReviewStatus: rowData.clientReviewStatus || false,
            accountantReviewStatus: rowData.accountantReviewStatus || false,
            descriptionNeedsEmployeeName: rowData.descriptionNeedsEmployeeName || false,
            clientApprovedTaxableFringeBenefit: rowData.clientApprovedTaxableFringeBenefit || false,
            accountantPostedTaxableFringeBenefit: rowData.accountantPostedTaxableFringeBenefit || false,
            memoOrDescription: this.state.editData.memoOrDescription
        };

        let descriptionBody = {
            id: rowData.id,
            memoOrDescription: this.state.editData.memoOrDescription,
            reportType: ReportType.TransactionsToBeReview,
            createdByName: null
        }

        this.setState({
            loading: true,
            pendingDescriptionBody: descriptionBody,
            pendingTfbOnlySave: false
        }, () => {
            this.props.LedgerUpdate(data, this.state.companyId, "Transaction updated successfully.");
        });
    }

    redirectToTransaction(endPoint) {
        let origin = makeLinkForQuickbooks()
        // const url = `https://app.qbo.intuit.com${endPoint}`;
        let url = origin + endPoint;
        window.open(url, '_blank');
    }

    render() {
        let selectedItem = this.state.SelectedRecords;
        return (
            <div className="dashboardPage transactions-to-be-review data-entry-issues-page tran-to-be-review-page">
                <div className="page-heading page-title-box d-sm-flex justify-content-sm-between align-items-sm-center">
                    <h2 className="mb-3 mb-sm-0">{JSON.parse(localStorage.getItem('userData')) != null ? JSON.parse(localStorage.getItem('userData')).companyName : ""} | Transactions to be Reviewed</h2>
                </div>

                {/*Top Header*/}
                <div className="padding-box app-wrapper" style={{ paddingBottom: "10px" }}>
                    <div className="row">
                        {/* Left Side Date Section */}
                        <div className="col-md-6">
                            <div className="datepicker-box d-flex align-items-center">
                                <div className="d-flex align-items-center">
                                    <div className="date-box">
                                        <DatePicker
                                            selected={this.state.sDate}
                                            onChange={(e) => this.handleDateChange(e, 'fromDate')}
                                            name="fromDate"
                                            id="date"
                                            required={true}
                                            margin="normal"
                                            disabledKeyboardNavigation
                                            showMonthDropdown
                                            showYearDropdown
                                            yearDropdownItemNumber={5}
                                            maxDate={this.state.eDate}
                                            ref={this.sDateRef}
                                        />
                                        <div className="date-icon" onClick={(e) => this.handleFocus(e, 'sDate')}>
                                            <i className="zmdi zmdi-calendar-note"></i>
                                        </div>
                                    </div>
                                    <div className="to-box">
                                        <span className="text-center ledgerto-text">To</span>
                                    </div>
                                    <div className="date-box">
                                        <DatePicker
                                            selected={this.state.eDate}
                                            onChange={(e) => this.handleDateChange(e, 'uptoDate')}
                                            name="uptoDate"
                                            id="date"
                                            required={true}
                                            margin="normal"
                                            showMonthDropdown
                                            showYearDropdown
                                            yearDropdownItemNumber={5}
                                            disabledKeyboardNavigation
                                            minDate={this.state.sDate}
                                            maxDate={new Date()}
                                            ref={this.eDateRef}
                                        />
                                        <div className="date-icon" onClick={(e) => this.handleFocus(e, 'eDate')}>
                                            <i className="zmdi zmdi-calendar-note"></i>
                                        </div>
                                    </div>
                                </div>
                                <div className="genera-apply-btn" style={{ marginLeft: "15px" }}>
                                    <Button
                                        variant="contained"
                                        className="greencolor jr-btn bg-teal text-white refresh-btn"
                                        onClick={(e) => this.ApplyDate()}
                                    >
                                        Apply
                                    </Button>
                                </div>
                            </div>
                        </div>

                        {/* Right Side Button Section */}
                        <div className="col-12 col-md-6">
                            <div className='d-flex justify-content-end align-items-center'>
                                <div className=''>
                                    <label className="form-group d-flex mb-0 align-items-center" style={{ marginRight: "20px", cursor: "pointer", whiteSpace: "nowrap" }}>
                                        <h4 className="col-form-label">Show All Queries</h4>
                                        <Switch color="default" checked={this.state.showAllSections} onChange={this.toggleShowAllSections} />
                                    </label>
                                </div>
                                <div className='show-previously-box'>
                                    <div className="form-group d-flex mb-0">
                                        <h4 htmlFor="staticEmail" className="col-form-label">Show Previously Ignored Transactions:</h4>
                                        <div className="dropdown-input-box">
                                            <select style={{ backgroundColor: "#fff", marginRight: "10px" }} className="select-box arrow-box" onChange={this.HandleIgnored} value={this.state.isIgnore} >
                                                <option value={true}> YES </option>
                                                <option value={false}> NO </option>
                                            </select>
                                        </div>
                                    </div>
                                </div>
                                <div className=''>
                                    <div className="form-group d-flex mb-0 align-items-center">
                                        <Button variant="contained" className=" jr-btn graycolor text-white refresh-btn" onClick={() => this.OnApplyIgnored()} >{this.state.isIgnore ? "Revert" : "Ignore"}</Button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                {/* Table Section - Show the Trasactions To Be Reviewed data */}

                {this.state.loading ? (
                    <CircularProgress></CircularProgress>
                ) : this.state.isDataLoaded ? (
                    <React.Fragment>
                        <div className="padding-box app-wrapper account-reconcilliation balancereview-page" style={{ paddingTop: "0px" }}>
                            <div className="table-responsive-material" ref={this.tbrTableWrapRef}>
                                <table className={`table tablebox account-reconcilliation tran-to-be-review-table`}>
                                    <thead className="panel-bg white_header_text">
                                        <tr style={{ backgroundColor: '#46b29d' }}>
                                            <th className={`${this.state.sortField == 'date' ? this.state.sortFormat == 'A'
                                                ? "asending" : "desending" : ''}`} onClick={() => this.onSortChange('date')}>
                                                <p className="table-th-title">Date</p>
                                            </th>
                                            <th className={`${this.state.sortField == 'transactionType' ?
                                                this.state.sortFormat == 'A'
                                                    ? "asending" : "desending" : ''}`} onClick={() => this.onSortChange('transactionType')}>
                                                <p className="table-th-title">Type</p>
                                            </th>
                                            <th className={`${this.state.sortField == 'name' ?
                                                this.state.sortFormat == 'A'
                                                    ? "asending" : "desending" : ''}`} onClick={() => this.onSortChange('name')}>
                                                <p className="table-th-title">Name</p>
                                            </th>
                                            <th className={`${this.state.sortField == 'accountNumber' ?
                                                this.state.sortFormat == 'A'
                                                    ? "asending" : "desending" : ''}`} onClick={() => this.onSortChange('accountNumber')}>
                                                <p className="table-th-title">Account #</p>
                                            </th>
                                            <th className={`text-right tbr-col-balance ${this.state.sortField == 'amount' ?
                                                this.state.sortFormat == 'A'
                                                    ? "asending" : "desending" : ''}`} onClick={() => this.onSortChange('amount')}>
                                                <p className="table-th-title">Balance</p>
                                            </th>
                                            <th className={`${this.state.sortField == 'memoOrDescription' ?
                                                this.state.sortFormat == 'A'
                                                    ? "asending" : "desending" : ''}`} onClick={() => this.onSortChange('memoOrDescription')}>
                                                <p className="table-th-title">Memo/Description</p>
                                            </th>
                                            <th className={`${this.state.sortField == 'internalNotes' ?
                                                this.state.sortFormat == 'A'
                                                    ? "asending" : "desending" : ''}`} onClick={() => this.onSortChange('internalNotes')}>
                                                <p className="table-th-title">Internal Notes</p>
                                            </th>
                                            <th className={`${this.state.sortField == 'accountantComment' ?
                                                this.state.sortFormat == 'A'
                                                    ? "asending" : "desending" : ''}`} onClick={() => this.onSortChange('accountantComment')}>
                                                <p className="table-th-title">Questions and Comments</p>
                                            </th>
                                            <th className={`tbr-col-new-ac ${this.state.sortField == 'newAccountName' ?
                                                this.state.sortFormat == 'A'
                                                    ? "asending" : "desending" : ''}`} onClick={() => this.onSortChange('newAccountName')}>
                                                <p className="table-th-title">New Account #</p>
                                            </th>
                                            {/* <th>New AC Name</th> */}
                                            <th className="text-center tbr-col-nbd">NBD</th>
                                            <th className="text-center tbr-col-ignore" title="Ignore" onClick={(e) => e.stopPropagation()}>
                                                <label className="container101 header-check tbr-ignore-header-cb">
                                                    <input className="second-check-box" type="checkbox" disabled tabIndex={-1} aria-hidden="true" />
                                                    <span className="checkmark101 white_border"></span>
                                                </label>
                                            </th>
                                            <th className="text-center tbr-col-qbo">
                                                <svg
                                                    className="tbr-header-qbo-icon"
                                                    xmlns="http://www.w3.org/2000/svg"
                                                    viewBox="0 0 24 24"
                                                    fill="none"
                                                    stroke="#fff"
                                                    strokeWidth="2"
                                                    strokeLinecap="round"
                                                    strokeLinejoin="round"
                                                    aria-hidden="true"
                                                >
                                                    <path d="M18 13v6a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h6" />
                                                    <polyline points="15 3 21 3 21 9" />
                                                    <line x1="10" y1="14" x2="21" y2="3" />
                                                </svg>
                                            </th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {this.getVisibleCategories().length === 0 && (
                                            <tr>
                                                <td colSpan="12" className="text-center">No transactions to review. Click Show All to see every section.</td>
                                            </tr>
                                        )}
                                        {this.getVisibleCategories().map(({ categoryIndex, ...category }) => (
                                            <React.Fragment key={`category_${category.key}`}>
                                                {/* Category Header */}
                                                <tr className={`transaction-to-be-reviewed-tr ${this.isCategoryExpanded(category.key) ? 'bg-active' : '' }`}
                                                    onClick={() => this.toggleCategory(category.key)}
                                                    style={{ cursor: 'pointer' }}
                                                >
                                                    <td className="title-name" colSpan="9">
                                                        <div className="tbr-category-header">
                                                        {this.isCategoryExpanded(category.key) ? (<i className="zmdi zmdi-minus-circle-outline green-minus-circle"></i> ) : ( <i className="zmdi zmdi-plus-circle-o"></i>  )}
                                                        {TBR_SECTION_INFO[category.key] && (
                                                            <span
                                                                id={`tbr-info-${category.key}`}
                                                                className="tbr-info-icon"
                                                                role="button"
                                                                tabIndex={0}
                                                                aria-label={`About ${category.label}`}
                                                                onMouseEnter={() => this.onInfoIconEnter(category.key)}
                                                                onMouseLeave={this.onInfoIconLeave}
                                                                onClick={(e) => this.onInfoIconClick(e, category.key)}
                                                                onKeyDown={(e) => this.onInfoIconKeyDown(e, category.key)}
                                                            >
                                                                <TbrInfoDocIcon />
                                                            </span>
                                                        )}
                                                        {!TBR_SECTION_INFO[category.key] && (
                                                            <span className="tbr-info-icon tbr-info-icon-empty" aria-hidden="true" />
                                                        )}
                                                        <span className="account-text">{category.label} ({category.data.length})
                                                            {category.key === 'transactionsInAccountsWithNoAccountNumber' && category.data.length === 0 && (
                                                                <span style={{ marginLeft: '40px' }}>This company does not use account numbers.</span>
                                                            )}
                                                            {category.key === 'stateSalesTaxCompliance' && (
                                                                <span style={{ marginLeft: '20px', display: 'inline-flex', alignItems: 'center' }} onClick={(e) => e.stopPropagation()}>
                                                                    <RSelect
                                                                        className="basic-single"
                                                                        classNamePrefix="select"
                                                                        value={this.getSelectedStateSaleTaxOption()}
                                                                        options={STATE_SALE_TAX_OPTIONS}
                                                                        onChange={this.onStateSaleTaxOptionChange}
                                                                        isDisabled={this.state.savingTbrSettings}
                                                                        menuPortalTarget={typeof document !== 'undefined' ? document.body : null}
                                                                        styles={tbrTitleSelectStyles}
                                                                    />
                                                                </span>
                                                            )}
                                                            {category.key === 'confirmGroupMedicalCoverage' && (
                                                                <span style={{ marginLeft: '20px', display: 'inline-flex', alignItems: 'center' }} onClick={(e) => e.stopPropagation()}>
                                                                    <RSelect
                                                                        className="basic-single"
                                                                        classNamePrefix="select"
                                                                        value={this.getSelectedGroupMedicalCoverageOption()}
                                                                        options={GROUP_MEDICAL_COVERAGE_OPTIONS}
                                                                        onChange={this.onGroupMedicalCoverageOptionChange}
                                                                        isDisabled={this.state.savingTbrSettings}
                                                                        menuPortalTarget={typeof document !== 'undefined' ? document.body : null}
                                                                        styles={tbrTitleSelectStyles}
                                                                    />
                                                                </span>
                                                            )}
                                                            {category.key === 'confirmGroupMedicalCoverage' && this.state.ignoredVendors.length > 0 && (
                                                                <span style={{ marginLeft: '16px', display: 'inline-flex', alignItems: 'center' }} onClick={(e) => e.stopPropagation()}>
                                                                    <button type="button" id="tbr-ignored-vendors-link" className="btn btn-link p-0 tbr-ignored-vendors-link"
                                                                        onClick={() => this.setState(prev => ({ ignoredVendorsOpen: !prev.ignoredVendorsOpen }))}>
                                                                        Ignored vendors ({this.state.ignoredVendors.length})
                                                                    </button>
                                                                </span>
                                                            )}
                                                            {category.key === 'confirmPersonalVsKeymanLifeInsurance' && (
                                                                <span style={{ marginLeft: '20px', display: 'inline-flex', alignItems: 'center' }} onClick={(e) => e.stopPropagation()}>
                                                                    <RSelect
                                                                        className="basic-single"
                                                                        classNamePrefix="select"
                                                                        value={this.getSelectedPersonalVsKeymanLifeInsuranceOption()}
                                                                        options={PERSONAL_VS_KEYMAN_LIFE_INSURANCE_OPTIONS}
                                                                        onChange={this.onPersonalVsKeymanLifeInsuranceOptionChange}
                                                                        isDisabled={this.state.savingTbrSettings}
                                                                        menuPortalTarget={typeof document !== 'undefined' ? document.body : null}
                                                                        styles={tbrTitleSelectStyles}
                                                                    />
                                                                </span>
                                                            )}
                                                            {category.key === 'reviewForPotentialUBIT' && (
                                                                <span style={{ marginLeft: '20px', display: 'inline-flex', alignItems: 'center' }} onClick={(e) => e.stopPropagation()}>
                                                                    <RSelect
                                                                        className="basic-single"
                                                                        classNamePrefix="select"
                                                                        value={this.getSelectedReviewForPotentialUBITOption()}
                                                                        options={REVIEW_FOR_POTENTIAL_UBIT_OPTIONS}
                                                                        onChange={this.onReviewForPotentialUBITOptionChange}
                                                                        isDisabled={this.state.savingTbrSettings}
                                                                        menuPortalTarget={typeof document !== 'undefined' ? document.body : null}
                                                                        styles={tbrTitleSelectStyles}
                                                                    />
                                                                </span>
                                                            )}
                                                            {category.key === 'reviewPotentialACAViolations' && (
                                                                <span style={{ marginLeft: '20px', display: 'inline-flex', alignItems: 'center' }} onClick={(e) => e.stopPropagation()}>
                                                                    <span style={{ marginRight: '8px', fontWeight: 400 }}>Last ACA Violation Notice to Client</span>
                                                                    <div className="datepicker-box" style={{ display: 'inline-flex', alignItems: 'center' }}>
                                                                        <div className="date-box">
                                                                            <DatePicker
                                                                                selected={this.parseTbrSettingsDate(this.state.tbrSettings && this.state.tbrSettings.reviewPotentialACADate)}
                                                                                onChange={this.onReviewPotentialACADateChange}
                                                                                name="reviewPotentialACADate"
                                                                                id="date"
                                                                                isClearable={true}
                                                                                disabled={this.state.savingTbrSettings}
                                                                                disabledKeyboardNavigation
                                                                                showMonthDropdown
                                                                                showYearDropdown
                                                                                yearDropdownItemNumber={5}
                                                                                maxDate={new Date()}
                                                                                placeholderText=""
                                                                                dateFormat="MM/dd/yyyy"
                                                                                ref={this.acaDateRef}
                                                                            />
                                                                            {!(this.state.tbrSettings && this.state.tbrSettings.reviewPotentialACADate) && (
                                                                                <div className="date-icon" onClick={(e) => this.handleFocus(e, 'acaDate')}>
                                                                                    <i className="zmdi zmdi-calendar-note"></i>
                                                                                </div>
                                                                            )}
                                                                        </div>
                                                                    </div>
                                                                </span>
                                                            )}
                                                            {category.key === 'reviewPotentialPersonalVehicleExpenseIssues' && (
                                                                <span style={{ marginLeft: '20px', display: 'inline-flex', alignItems: 'center' }} onClick={(e) => e.stopPropagation()}>
                                                                    <span style={{ marginRight: '8px', fontWeight: 400 }}>Last Personal Vehicle Expense Notice to Client</span>
                                                                    <div className="datepicker-box" style={{ display: 'inline-flex', alignItems: 'center' }}>
                                                                        <div className="date-box">
                                                                            <DatePicker
                                                                                selected={this.parseTbrSettingsDate(this.state.tbrSettings && this.state.tbrSettings.reviewPotentialPersonalVehicleExpenseDate)}
                                                                                onChange={this.onReviewPotentialPersonalVehicleExpenseDateChange}
                                                                                name="reviewPotentialPersonalVehicleExpenseDate"
                                                                                id="date"
                                                                                isClearable={true}
                                                                                disabled={this.state.savingTbrSettings}
                                                                                disabledKeyboardNavigation
                                                                                showMonthDropdown
                                                                                showYearDropdown
                                                                                yearDropdownItemNumber={5}
                                                                                maxDate={new Date()}
                                                                                placeholderText=""
                                                                                dateFormat="MM/dd/yyyy"
                                                                                ref={this.vehicleDateRef}
                                                                            />
                                                                            {!(this.state.tbrSettings && this.state.tbrSettings.reviewPotentialPersonalVehicleExpenseDate) && (
                                                                                <div className="date-icon" onClick={(e) => this.handleFocus(e, 'vehicleDate')}>
                                                                                    <i className="zmdi zmdi-calendar-note"></i>
                                                                                </div>
                                                                            )}
                                                                        </div>
                                                                    </div>
                                                                </span>
                                                            )}
                                                            {category.key === 'confirmBusinessVehicleExpenses' && (
                                                                <span style={{ marginLeft: '20px', display: 'inline-flex', alignItems: 'center' }} onClick={(e) => e.stopPropagation()}>
                                                                    <span style={{ marginRight: '8px', fontWeight: 400 }}>Last Business Vehicle Expense Notice to Client</span>
                                                                    <div className="datepicker-box" style={{ display: 'inline-flex', alignItems: 'center' }}>
                                                                        <div className="date-box">
                                                                            <DatePicker
                                                                                selected={this.parseTbrSettingsDate(this.state.tbrSettings && this.state.tbrSettings.businessVehicleExpensesDate)}
                                                                                onChange={this.onBusinessVehicleExpensesDateChange}
                                                                                name="businessVehicleExpensesDate"
                                                                                id="date"
                                                                                isClearable={true}
                                                                                disabled={this.state.savingTbrSettings}
                                                                                disabledKeyboardNavigation
                                                                                showMonthDropdown
                                                                                showYearDropdown
                                                                                yearDropdownItemNumber={5}
                                                                                maxDate={new Date()}
                                                                                placeholderText=""
                                                                                dateFormat="MM/dd/yyyy"
                                                                                ref={this.businessVehicleDateRef}
                                                                            />
                                                                            {!(this.state.tbrSettings && this.state.tbrSettings.businessVehicleExpensesDate) && (
                                                                                <div className="date-icon" onClick={(e) => this.handleFocus(e, 'businessVehicleDate')}>
                                                                                    <i className="zmdi zmdi-calendar-note"></i>
                                                                                </div>
                                                                            )}
                                                                        </div>
                                                                    </div>
                                                                </span>
                                                            )}
                                                        </span>
                                                        </div>
                                                    </td>

                                                    <td className="text-center tbr-col-nbd"></td>
                                                    <td className="text-center tbr-col-ignore">
                                                        {category.key !== 'transactionsInAccountsWithNoAccountNumber' && (
                                                            <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                                                                <label className="container101" onClick={(e) => e.stopPropagation()}>
                                                                    <input
                                                                        className="second-check-box"
                                                                        type="checkbox"
                                                                        checked={this.isCategoryAllIgnoreSelected(category.key, this.getIgnoreSelectableRows(category.data))}
                                                                        onChange={(e) =>
                                                                            this.handleSelectAllIgnoreCategory(
                                                                                category.key,
                                                                                this.getIgnoreSelectableRows(category.data),
                                                                                e.target.checked
                                                                            )
                                                                        }
                                                                    />
                                                                    <span className="checkmark101"></span>
                                                                </label>
                                                            </div>
                                                        )}
                                                    </td>
                                                    <td className="tbr-col-qbo"></td>
                                                </tr>


                                                {/* Transactions within Category */}
                                                {this.isCategoryExpanded(category.key) &&
                                                    <>
                                                        {category.key === 'transactionsInAccountsWithNoAccountNumber' ? (
                                                            <>
                                                                {/* Same 12 columns as main header: Date, Type, Name, Account #, Balance, Memo/Desc., Internal Notes, Questions and Comments, New Account #, NBD, Ignore, Link */}
                                                                {category.data.map((transaction, transactionIndex) => {
                                                                    const balance = transaction.balance != null ? transaction.balance : (transaction.Balance != null ? transaction.Balance : transaction.amount);
                                                                    const formattedBalance = formatCurrencyAmount(balance);
                                                                    const accountName = transaction.accountName != null ? transaction.accountName : (transaction.AccountName != null ? transaction.AccountName : '');
                                                                    return (
                                                                        <tr key={`transaction_${categoryIndex}_${transactionIndex}`} className="account-type-row">
                                                                            <td></td>
                                                                            <td></td>
                                                                            <td></td>
                                                                            <td>{accountName}</td>
                                                                            <td className="text-right" style={{ fontVariantNumeric: 'tabular-nums' }}>{formattedBalance}</td>
                                                                            <td></td>
                                                                            <td></td>
                                                                            <td></td>
                                                                            <td className="tbr-col-new-ac"></td>
                                                                            <td className="tbr-col-nbd"></td>
                                                                            <td className="tbr-col-ignore"></td>
                                                                            <td className="tbr-col-qbo"></td>
                                                                        </tr>
                                                                    );
                                                                })}
                                                            </>
                                                        ) : (
                                                        <>
                                                        {category.data.map((transaction, transactionIndex) => (
                                                            <React.Fragment key={`transaction_${categoryIndex}_${transactionIndex}`}>
                                                                <tr onClick={(e) => this.onRowClick(e, category.key, categoryIndex, transactionIndex, transaction)} className="account-type-row" style={{ cursor: 'pointer' }}>
                                                                    <td>{GetFormatedDate(transaction.date)}</td>
                                                                    <td>{transaction.transactionType}</td>
                                                                    <td>
                                                                        {transaction.name}
                                                                        {this.state.isIgnore && category.key === 'confirmGroupMedicalCoverage' && transaction.isVendorIgnored && (
                                                                            <span className="tbr-vendor-ignored-tag">Ignored by vendor</span>
                                                                        )}
                                                                    </td>
                                                                    <td>{this.formatAccountLabel(transaction.accountNumber, transaction.accountName)}</td>
                                                                    <td className="text-right" style={{ fontVariantNumeric: 'tabular-nums' }}>{formatCurrencyAmount(transaction.amount)}</td>
                                                                    <td className="textOverFlow">{transaction.memoOrDescription}</td>
                                                                    <td>{transaction.internalNotes}</td>
                                                                    <td>{transaction.accountantComment}</td>
                                                                    {/* <td>{transaction.newAccountId}</td> */}
                                                                    <td className="tbr-col-new-ac">{this.formatNewAccountLabel(transaction)}</td>
                                                                    <td className="text-center tbr-col-nbd">
                                                                        {this.isTransactionNbdChecked(transaction) ? (
                                                                            <i className="zmdi zmdi-check" title="Needs Better Description"></i>
                                                                        ) : null}
                                                                    </td>
                                                                    <td className="text-center tbr-col-ignore" onClick={(e) => e.stopPropagation()}>
                                                                        <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                                                                            <label className="container101">
                                                                                <input
                                                                                    className="second-check-box" type="checkbox"
                                                                                    checked={this.isTransactionIgnoreSelected(category.key, transaction.id)}
                                                                                    disabled={this.isVendorOnlyIgnored(transaction)}
                                                                                    title={this.isVendorOnlyIgnored(transaction) ? 'Ignored by vendor - untick Ignore Vendor in the edit row to restore' : undefined}
                                                                                    onChange={(e) => {
                                                                                        e.stopPropagation();
                                                                                        this.handleIgnoreCheckbox(category.key, transaction.id, e.target.checked);
                                                                                    }}
                                                                                />
                                                                                <span className="checkmark101"></span>
                                                                            </label>
                                                                        </div>
                                                                    </td>
                                                                    {/* <td>{transaction.transactionLink}</td> */}
                                                                    <td className="text-center tbr-col-qbo" onClick={(e) => e.stopPropagation()}>
                                                                        {
                                                                            <img alt="QBDlink" src="/vendors/Shape 1.png"
                                                                                onClick={(e) => { e.stopPropagation(); this.redirectToTransaction(transaction.transactionLink); }}
                                                                                style={{ cursor: "pointer" }}
                                                                            />
                                                                        }
                                                                    </td>
                                                                </tr>

                                                                {this.state.editIndex1 === categoryIndex && this.state.editIndex === transactionIndex &&
                                                                    <React.Fragment>
                                                                        <tr className="editRowColor">
                                                                            <td colSpan="3" style={{ verticalAlign: 'top' }}>
                                                                                <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start', width: '100%' }}>
                                                                                    <label style={{ marginBottom: '6px' }}>New Account</label>
                                                                                    <div style={{ width: '100%' }}>
                                                                                        <RSelect
                                                                                            required={true}
                                                                                            name="NewAccountID"
                                                                                            value={this.state.selectedAccount}
                                                                                            onChange={(e) => this.handalAccountDropdown(e, categoryIndex, transactionIndex, transaction)}
                                                                                            options={this.state.DisplayAccounts}
                                                                                            placeholder="Select"
                                                                                            menuPortalTarget={typeof document !== 'undefined' ? document.body : null}
                                                                                            styles={tbrNewAccountSelectStyles}
                                                                                        />
                                                                                    </div>
                                                                                </div>
                                                                            </td>
                                                                            <td colSpan={this.isTfbEditCategory(category.key) ? 4 : 5} style={{ verticalAlign: 'top' }}>
                                                                                <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start', width: '100%' }}>
                                                                                    <label style={{ marginBottom: '6px' }}>Memo/Description</label>
                                                                                    <Textarea className="placheholder-color"
                                                                                        value={this.state.editData.memoOrDescription} name="memoOrDescription"
                                                                                        style={{ 'lineHeight': '20px', width: '100%', border: 'none', resize: 'none', padding: '6px', paddingLeft: '10px', borderRadius: '3px', border: '1px solid #ccc', overflow: 'hidden' }}
                                                                                        resize={"false"} placeholder=""
                                                                                        onChange={(e) => this.handalTextArea(e, categoryIndex, transactionIndex, transaction)} />
                                                                                </div>
                                                                            </td>
                                                                            <td colSpan={this.isTfbEditCategory(category.key) ? 5 : 4} style={{ verticalAlign: 'top' }}>
                                                                                <div style={{
                                                                                    display: 'flex',
                                                                                    flexDirection: 'row',
                                                                                    flexWrap: 'nowrap',
                                                                                    alignItems: 'center',
                                                                                    justifyContent: 'flex-start',
                                                                                    gap: '16px',
                                                                                    marginTop: '30px',
                                                                                    whiteSpace: 'nowrap'
                                                                                }}>
                                                                                    {this.isTfbEditCategory(category.key) && (
                                                                                        <div className="chiller_cb" style={{ marginBottom: 0 }}>
                                                                                            <input id={`taxableFringeBenefit_${categoryIndex}_${transactionIndex}`} name="taxableFringeBenefit" type="checkbox" checked={this.state.editData.taxableFringeBenefit || false} onChange={(e) => this.handalCheckbox(e, categoryIndex, transactionIndex, transaction)} />
                                                                                            <label htmlFor={`taxableFringeBenefit_${categoryIndex}_${transactionIndex}`}>
                                                                                                <p className="checkbox-title">TFB</p>
                                                                                            </label>
                                                                                            <span></span>
                                                                                        </div>
                                                                                    )}
                                                                                    <div className="chiller_cb" style={{ marginBottom: 0 }}>
                                                                                        <input id={`needsBetterDescription_${categoryIndex}_${transactionIndex}`} name="needsBetterDescription" type="checkbox" checked={this.state.editData.needsBetterDescription || false} onChange={(e) => this.handalCheckbox(e, categoryIndex, transactionIndex, transaction)} />
                                                                                        <label htmlFor={`needsBetterDescription_${categoryIndex}_${transactionIndex}`}>
                                                                                            <p className="checkbox-title">Need Better Description</p>
                                                                                        </label>
                                                                                        <span></span>
                                                                                    </div>
                                                                                    {this.canIgnoreVendor(category.key, transaction) && (
                                                                                        <div className="chiller_cb" style={{ marginBottom: 0 }} title={`Ignore all current and future Confirm Group Medical Coverage transactions for ${this.getVendorLabel(transaction)}`}>
                                                                                            <input id={`ignoreVendor_${categoryIndex}_${transactionIndex}`} name="ignoreVendor" type="checkbox" checked={this.state.editData.ignoreVendor || false} onChange={(e) => this.handalCheckbox(e, categoryIndex, transactionIndex, transaction)} />
                                                                                            <label htmlFor={`ignoreVendor_${categoryIndex}_${transactionIndex}`}>
                                                                                                <p className="checkbox-title">Ignore Vendor</p>
                                                                                            </label>
                                                                                            <span></span>
                                                                                        </div>
                                                                                    )}
                                                                                </div>
                                                                            </td>
                                                                        </tr>
                                                                        <tr className="editRowColor tbr-edit-row-2">
                                                                            <td colSpan="12" className="tbr-edit-row-2-cell">
                                                                                <div className="tbr-edit-row-2-inner">
                                                                                    <div className="tbr-edit-field tbr-edit-field-qc">
                                                                                        <label className="tbr-edit-label">Questions and Comments:</label>
                                                                                        <Textarea className="placheholder-color tbr-edit-textarea"
                                                                                            value={this.state.editData.accountantComment} name="accountantComment"
                                                                                            style={{ lineHeight: '20px', width: '100%', border: 'none', resize: 'none', padding: '6px', paddingLeft: '10px', borderRadius: '3px', border: '1px solid #ccc', overflow: 'hidden' }}
                                                                                            resize={"false"} placeholder=""
                                                                                            onChange={(e) => this.handalTextArea(e, categoryIndex, transactionIndex, transaction)} />
                                                                                    </div>
                                                                                    <div className="tbr-edit-field tbr-edit-field-notes">
                                                                                        <label className="tbr-edit-label">Internal Notes:</label>
                                                                                        <Textarea className="placheholder-color tbr-edit-textarea"
                                                                                            value={this.state.editData.internalNotes} name="internalNotes"
                                                                                            style={{ lineHeight: '20px', width: '100%', border: 'none', resize: 'none', padding: '6px', paddingLeft: '10px', borderRadius: '3px', border: '1px solid #ccc', overflow: 'hidden' }}
                                                                                            resize={"false"} placeholder=""
                                                                                            onChange={(e) => this.handalTextArea(e, categoryIndex, transactionIndex, transaction)} />
                                                                                    </div>
                                                                                    <div className="tbr-edit-actions">
                                                                                        <Button variant="contained" className="jr-btn jr-btn-sm bg-teal text-white" onClick={() => this.onRowUpdateClick(categoryIndex, transactionIndex, transaction)}>SAVE</Button>
                                                                                        <Button variant="contained" className="jr-btn jr-btn-sm bg-danger text-white" onClick={() => this.onRowCancelClick(categoryIndex, transactionIndex, transaction)}>CANCEL</Button>
                                                                                    </div>
                                                                                </div>
                                                                            </td>
                                                                        </tr>
                                                                    </React.Fragment>
                                                                }
                                                            </React.Fragment>
                                                        ))}
                                                        </>
                                                        )}
                                                    </>
                                                }
                                            </React.Fragment>
                                        ))}
                                    </tbody>
                                </table>
                                {this.state.infoCategoryKey && TBR_SECTION_INFO[this.state.infoCategoryKey] && (
                                    <Popover
                                        key={this.state.infoCategoryKey}
                                        isOpen={true}
                                        target={`tbr-info-${this.state.infoCategoryKey}`}
                                        toggle={this.closeInfoPopover}
                                        placement="bottom"
                                        modifiers={{
                                            preventOverflow: { boundariesElement: this.tbrTableWrapRef.current || 'viewport', priority: ['left', 'right'], padding: 12 },
                                            flip: { enabled: true, behavior: 'flip', boundariesElement: 'viewport' }
                                        }}
                                        className="tbr-info-popover"
                                    >
                                        <PopoverBody>
                                            {TBR_SECTION_INFO[this.state.infoCategoryKey]}
                                            {this.state.infoCategoryKey === 'stateSalesTaxCompliance' && this.renderSalesTaxSearch()}
                                        </PopoverBody>
                                    </Popover>
                                )}
                                {this.state.ignoredVendorsOpen && this.state.ignoredVendors.length > 0
                                    && this.getVisibleCategories().some(category => category.key === 'confirmGroupMedicalCoverage') && (
                                    <Popover
                                        isOpen={true}
                                        target="tbr-ignored-vendors-link"
                                        toggle={() => this.setState({ ignoredVendorsOpen: false })}
                                        placement="bottom"
                                        modifiers={{ preventOverflow: { boundariesElement: 'viewport', padding: 12 } }}
                                        className="tbr-ignored-vendors-popover"
                                    >
                                        <PopoverBody>
                                            <table className="table table-sm mb-0">
                                                <thead>
                                                    <tr>
                                                        <th>Vendor</th>
                                                        <th>Ignored By</th>
                                                        <th>Ignored On</th>
                                                        <th></th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {this.state.ignoredVendors.map(vendor => (
                                                        <tr key={vendor.vendorID}>
                                                            <td>{vendor.vendorName}</td>
                                                            <td>{vendor.ignoredBy}</td>
                                                            <td>{vendor.ignoredOn ? GetFormatedDate(vendor.ignoredOn) : ''}</td>
                                                            <td className="text-right">
                                                                <Button variant="contained" className="jr-btn jr-btn-sm bg-teal text-white" onClick={() => this.restoreIgnoredVendor(vendor)}>Restore</Button>
                                                            </td>
                                                        </tr>
                                                    ))}
                                                </tbody>
                                            </table>
                                        </PopoverBody>
                                    </Popover>
                                )}
                                <Dialog open={!!this.state.confirmDialog} onClose={this.closeConfirm} maxWidth="xs">
                                    <DialogContent>{this.state.confirmDialog ? this.state.confirmDialog.message : ''}</DialogContent>
                                    <DialogActions>
                                        <Button onClick={this.closeConfirm}>Cancel</Button>
                                        <Button variant="contained" className="jr-btn bg-teal text-white" onClick={this.onConfirmDialogContinue}>Continue</Button>
                                    </DialogActions>
                                </Dialog>
                            </div>
                        </div>
                    </React.Fragment>
                ) : null}
            </div>
        )
    }
}

const mapStateToProps = (state) => {
    return {
        ReportData: state.ReportData.ReportData,
        UpdateDescription: state.ReportData.UpdateDescription,
        LEDGER_UPDATE: state.ledgers.LEDGER_UPDATE,
        accounts: state.accounts.accountsData,
        company: state.companyReducer.companyDeatils,
        states: state.companyReducer.states
    }
}

const mapDispatchToProps = (dispatch) => {
    return bindActionCreators({
        GET_REPORT_DATA,
        MARK_IGNORED_DATA,
        Revert_Ignored_DATA,
        LedgerUpdate,
        Accounts,
        UPDATE_DESCRIPTION_DATA,
        IGNORE_VENDOR,
        UNIGNORE_VENDOR,
        GET_IGNORED_VENDORS,
        getCompnay,
        getStates,
        UPSERT_TRANSACTION_TO_BE_REVIEWED_SETTINGS
    }, dispatch)
}



export default connect(mapStateToProps, mapDispatchToProps)(TransactionsToBeReviewComponent);